import React, { useState } from 'react'
import { Box, Dialog, DialogContent, Typography } from '@mui/material'

import { Button } from '~components/common'
import { ContactEntryId, EmailIdentity, IdentityId, TargetId } from '~types'

import AddContactFormControl, { ContactFormData } from './AddContactFormControl'

interface AddContactDialogProps {
  open: boolean
  onClose: () => void
  onComplete?: () => void
  onSaveSuccess?: (
    contactEntryId: ContactEntryId,
    identityId: IdentityId,
    targetId: TargetId,
  ) => void
  update?: boolean
  contactInfo?: ContactFormData
  inputOrganization?: EmailIdentity | null
}

const AddContactDialog: React.FC<AddContactDialogProps> = ({
  open,
  onClose,
  onComplete,
  onSaveSuccess,
  update,
  contactInfo,
  inputOrganization,
}) => {
  const [isFormValid, setIsFormValid] = useState<boolean>(false)
  const [saveCounter, setSaveCounter] = useState<number>(0)

  return (
    <Dialog open={open} onClose={onClose} maxWidth='md'>
      <Box className='flex-v-align' sx={{ ml: 2, mr: 2, mt: 2, borderBottom: '1px solid #ccc' }}>
        <Typography variant='h1' sx={{ p: 1, mb: 2 }}>
          {update ? 'Update Contact' : 'New Contact'}
        </Typography>
        <Box
          sx={{
            mb: 2,
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 2,
            ml: 'auto',
          }}
        >
          <Button onClick={onClose}>Cancel</Button>
          <Button
            variant='contained'
            color='secondary'
            onClick={() => setSaveCounter(saveCounter + 1)}
            disabled={isFormValid}
            sx={{ whiteSpace: 'nowrap' }}
          >
            {update ? 'Update Contact' : 'Save Contact'}
          </Button>
        </Box>
      </Box>
      <DialogContent>
        <Box
          noValidate
          component='form'
          sx={{
            display: 'flex',
            flexDirection: 'column',
            m: 'auto',
            width: '100%',
          }}
        >
          <AddContactFormControl
            initialData={contactInfo}
            onClose={onClose}
            onComplete={onComplete}
            saveCounter={saveCounter}
            onFormValidChange={setIsFormValid}
            onSaveSuccess={onSaveSuccess}
            inputOrganization={inputOrganization}
          />
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default AddContactDialog
